<template>
    <b-navbar id="bNavbar" toggleable="lg" type="light" variant="light">
        <b-navbar-brand v-if="kisi.isim" :to="{name: 'anasayfa'}">{{kisi.isim}}</b-navbar-brand>
        <b-navbar-brand v-else :to="{name: 'anasayfa'}">Kızılay Latinize</b-navbar-brand>
        <b-navbar-toggle target="nav-collapse"/>

        <b-collapse id="nav-collapse" is-nav>
            <nav-items/>
        </b-collapse>
    </b-navbar>
</template>

<script>
    import {mapGetters} from "vuex"
    import {iste} from "@/api/iste";
    import NavItems from "@/components/NavItems";

    export default {
        name: "navbar",
        computed: {
            ...mapGetters([
                'kisi'
            ])
        },
        components: {
            NavItems
        }
    }
</script>

<style>

</style>
